// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3yd2h";
var _4 = "vouchersList-3sxFy";
var _5 = "voucher-2x0VU";
var _6 = "voucher__header-3hqFT";
var _7 = "voucher__input-1Tpwr";
var _8 = "voucher__read-38nfC";
var _9 = "voucher__input_load-1GI-_";
var _a = "success-RUKk7";
var _b = "voucher__right-2lWTb";
var _c = "voucher__remove-1DcPx";
var _d = "voucher__remove_hidden-14ad3";
var _e = "footer-l6N0s";
var _f = "button-1-OpE";
var _10 = "button_loader-D-MiX";
var _11 = "button_disabled-H4vGI";
var _12 = "rotation-1qY3y";
var _13 = "voucher__add-1vMkB";
var _14 = "voucher__discount-2Zkws";
var _15 = "voucher__add_notAvailable-7JeP-";
var _16 = "info-1VD3j";
var _17 = "mobileTooltip-ATH0n";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "vouchersList", _5 as "voucher", _6 as "voucher__header", _7 as "voucher__input", _8 as "voucher__read", _9 as "voucher__input_load", _a as "success", _b as "voucher__right", _c as "voucher__remove", _d as "voucher__remove_hidden", _e as "footer", _f as "button", _10 as "button_loader", _11 as "button_disabled", _12 as "rotation", _13 as "voucher__add", _14 as "voucher__discount", _15 as "voucher__add_notAvailable", _16 as "info", _17 as "mobileTooltip" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "vouchersList": _4, "voucher": _5, "voucher__header": _6, "voucher__input": _7, "voucher__read": _8, "voucher__input_load": _9, "success": _a, "voucher__right": _b, "voucher__remove": _c, "voucher__remove_hidden": _d, "footer": _e, "button": _f, "button_loader": _10, "button_disabled": _11, "rotation": _12, "voucher__add": _13, "voucher__discount": _14, "voucher__add_notAvailable": _15, "info": _16, "mobileTooltip": _17 }
